import PropTypes from "prop-types"
import React from "react"

const sectionStyles = {
  margin: `0 auto`,
  maxWidth: `1400px`
};

const subSectionContainer = {
  display: `flex`,
  justifyContent: `space-evenly`,
  flexWrap: `wrap`,
  marginBottom: `2rem`
}

const contactContainerStyles = {
  textAlign: `center`,
  maxWidth: 250
}

const ContactSection = ({ accounts }) => (
  <section id="contact" style={sectionStyles}>
    <h1 className="section-header">Contact</h1>
    <div style={subSectionContainer}>
      {accounts.map((account, index) => (
        <div key={index} style={contactContainerStyles}>
          <a target="_blank" rel="noopener noreferrer" href={account.url} className="account-icons">
            {account.icon}
          </a>
        </div>
      ))}
    </div>
  </section>
)

ContactSection.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    icon: PropTypes.element,
  })),
}

ContactSection.defaultProps = {
  accounts: [],
}

export default ContactSection
